import { useEffect, useState } from 'react'
import { decodeImpersonationPayload, setImpersonationSession } from '../lib/impersonation'

// Landing page for a freshly-opened impersonation tab -- see
// lib/impersonation.ts's header comment for the full hand-off design. This
// component's only job is: read the fragment once, store the session, then
// hand off to a full browser navigation (not react-router's navigate) so
// App.tsx re-evaluates from scratch with the session already in
// sessionStorage. A client-side route change would leave App.tsx's route
// element -- computed once per App() render, not re-evaluated just because
// a child navigated -- still pointed at the MSAL-gated tree.
export default function ImpersonationEntry() {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fragment = window.location.hash.slice(1)
    const session = fragment ? decodeImpersonationPayload(fragment) : null

    if (!session) {
      setError('This impersonation link is invalid or has expired. Ask the admin who sent it to try again.')
      return
    }

    setImpersonationSession(session)
    // history.replaceState first: strips the token from this tab's
    // history entry before the reload -- window.location.replace alone
    // would still briefly leave the fragment in the address bar.
    window.history.replaceState(null, '', '/')
    window.location.replace('/')
  }, [])

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md space-y-3 text-center">
          <h1 className="text-xl font-semibold text-foreground">Impersonation link invalid</h1>
          <p className="text-sm text-muted-foreground">{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  )
}
